import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../utils/Hooks";
import { BreadcrumbLink } from "../../models/BreadcrumbLink";
import Breadcrumbs from "../common/Breadcrumbs";
import ElogInput from "../common/form/ElogInput";
import ElogSelect, { Option } from "../common/form/ElogSelect";
import ElogCheckbox from "../common/form/ElogCheckbox";
import {
    createVendor,
    resetCreateVendorStatus,
    getVendors,
} from "../../store/reducers/VendorsSlice";
import { RequestStatus } from "../../utils/Enums";
import { useNavigate } from "react-router-dom";
import CategoryType from "../../models/CategoryType";
import {apiClient} from "../../utils/ApiClient";
import {LoggedInView} from "../common/LoggedInView";
import ElogTextarea from "../common/form/ElogTextarea";
import {FormikProvider, useFormik, Field, Form } from "formik";
import {createSMSSender} from "../../store/reducers/SMSSendersSlice";

interface NewVendorScreenProps {}

export interface NewVendorFormProps {
    name: string;
    insurance: boolean,
    wca: boolean,
    wcaId: string;
    comment: string;
    contactName: string;
    contactPlea: string;
    contactEmail: string;
    contactPhone: string;
    contactComment: string;
    groups: string[];
}

export const NewVendorScreen: React.FC<NewVendorScreenProps> = () => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const vendorsState = useAppSelector((state) => state.vendors);
    const [categoryTypes, setCategoryTypes] = useState<CategoryType[]>([]);

    const requestStatus: RequestStatus = vendorsState.createVendorStatus;

    const breadcrumbLinks: BreadcrumbLink[] = [
        { text: "Hankijad", url: "/vendors" },
        { text: "Hankija lisamine", url: "/vendors/new" },
    ];

    const languageOptions: Option[] = [
        {value: 'est', label: 'Eesti'},
        {value: 'eng', label: 'Inglise'},
        //{value: 'fin', label: 'Soome'},
        //{value: 'swe', label: 'Rootsi'},
    ];

    useEffect(() => {
        if (requestStatus === RequestStatus.Success) {
            dispatch(resetCreateVendorStatus());
            navigate(breadcrumbLinks[0].url);
        }
    }, [requestStatus]);

    useEffect(() => {

        apiClient.get("category-types/all-by-category").then((response) => {
            setCategoryTypes(response.data);
        });

    }, []);

    // @ts-ignore
    const formik = useFormik({
        initialValues: {
            name: '',
            insurance: false,
            wca: false,
            wcaId: '',
            comment: '',
            contactName: '',
            contactPlea: '',
            contactEmail: '',
            contactPhone: '',
            contactComment: '',
            language: 'est',
            groups: []
        },
        validate: (values) => {
            const errors: Partial<NewVendorFormProps> = {};

            if (values.wca && !values.wcaId.trim()) {
                errors.wcaId = 'WCA ID on kohustuslik, kui WCA on märgitud';
            }

            return errors;
        },
        onSubmit: (values: any) => {
            dispatch(createVendor(values))
        },
        enableReinitialize: true
    });

    const {values, setFieldValue, handleSubmit} = formik;

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks} />
            {requestStatus === RequestStatus.Failed && vendorsState.errors.length > 0 && (
                <div className="message msg-error">
                    <div>
                        <h2>Viga:</h2>
                        {vendorsState.errors.map((error, index) => (
                            <span key={index}>{error}<br/></span>
                        ))}
                    </div>
                </div>
            )}
            <FormikProvider value={formik}>
                <Form onSubmit={handleSubmit}>
                    <div className="form">
                        <h2>
                            <span>Hankija andmed</span>
                        </h2>
                        <table className="form">
                            <tbody>
                            <ElogInput label="Nimi" name="name" mandatory={true} />
                            <ElogCheckbox
                                label="Kindlustus"
                                name="insurance"
                            />
                            <ElogCheckbox
                                label="WCA"
                                name="wca"
                            />
                            <ElogInput
                                label="WCA ID"
                                name="wcaId"
                                mandatory={values.wca}
                            />
                            <ElogTextarea label="Kommentaar" name="comment" />
                            </tbody>
                        </table>
                    </div>
                    <div className="form">
                        <h2>
                            <span>Peamine kontaktisik</span>
                        </h2>
                        <table className="form">
                            <tbody>
                            <ElogInput label="Nimi" name="contactName" mandatory={true} />
                            <ElogInput label="Pöördumine" name="contactPlea" mandatory={true} />
                            <ElogInput label="E-post" name="contactEmail" mandatory={true} />
                            <ElogInput label="Telefon" name="contactPhone" mandatory={true} />
                            <ElogTextarea label="Kommentaar" name="contactComment" />
                            <ElogSelect label="Keel" name="language" options={languageOptions} mandatory={true}/>
                            </tbody>
                        </table>
                    </div>

                    {categoryTypes.map((categoryType) => (
                        <div key={categoryType.id} className="form">
                            <h2>
                                <span>{categoryType.name}</span>
                            </h2>
                            {categoryType?.categories?.map((category) => (
                                <Field
                                    key={category.id}
                                    name="groups"
                                    type="checkbox"
                                    value={String(category.id)}
                                    render={(props: { field: { value: any; onChange: (e: React.ChangeEvent<any>) => void; onBlur: () => void; name: string } }) => (
                                        <>
                                            <label htmlFor={`group_${category.id}`}>{category.name}</label>
                                            <input
                                                {...props.field}
                                                id={`group_${category.id}`}
                                                type="checkbox" // Set the type attribute to "checkbox"
                                                onChange={(event) => props.field.onChange(event)}
                                                onBlur={() => undefined}
                                            />
                                        </>
                                    )}
                                />
                            ))}
                        </div>
                    ))}

                    <div className="action clear">
                        <p>
                            <button type="submit">
                            <span>
                                <strong>Sisesta</strong>
                            </span>
                            </button>
                            <a href="">Tühista</a>
                        </p>
                    </div>
                </Form>
            </FormikProvider>
        </LoggedInView>
    );
};
